import styled from "styled-components";

export const CalendarWeekItemStyled = styled.div`
  position: relative;
  box-sizing: border-box;
  border-right: 1px solid
    ${({ theme, isHoliday }) => (isHoliday ? theme.COLORS.GRAY_2 : "#e5e5e5")};
  border-bottom: 1px solid
    ${({ theme, isHoliday }) => (isHoliday ? theme.COLORS.GRAY_2 : "#e5e5e5")};
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 60px;
  background-color: ${({ isHoliday, theme }) =>
    isHoliday ? theme.COLORS.GRAY_2 : theme.COLORS.WHITE_1};
  .status_indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
    background-color: ${({ indicatorColor }) =>
      indicatorColor ? indicatorColor : "transparent"};
  }
  .cdw_list {
    padding: 4px 12px;
    .cdw_item {
      display: flex;
      align-items: baseline;
      column-gap: 4px;
      .event_name_label {
        color: ${({ theme }) => theme.COLORS.GRAY_2};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
      }
    }
  }

  .theme_standard {
  }
`;
